import { convertAppFormLoanReasonToLeadMarketLoanReason, convertAppIncomeSourceToLeadMarketIncomeSource } from "./appFormToLeadMarketMapper";

export const CreateLeadXml = ( values ) => {

      const doc = document.implementation.createDocument('', '' , null);
    
        const lead = createElement(doc, 'Lead');
    
        lead.appendChild(createSellerData(doc, values));
        lead.appendChild(createApplication(doc, values));
        lead.appendChild(createApplicant(doc, values));
        
        doc.appendChild(lead);
        
        return xmlToString(doc);
}

const createSellerData = (doc, values)  => {

    const sellerData = createElement(doc, 'Seller_Data');
    
    sellerData.appendChild(createElement(doc, 'Client_Authority', 'false'));    
    sellerData.appendChild(createElement(doc, 'Customer_Authority', 'true'));
    sellerData.appendChild(createElement(doc, 'Customer_Authority_Type', 'Implicit'));
    sellerData.appendChild(createElement(doc, 'Accept_Anti_Hawking', 'true'));
    sellerData.appendChild(createElement(doc, 'Use_MLM_Flow', 'true'));

    sellerData.appendChild(createElement(doc, 'Lead_Reference', values.accountExternalId));
        
    return sellerData;
}

const createApplication = (doc, values) => {
    
    const application = createElement(doc, 'Application');
    
    application.appendChild(createElement(doc, 'Application_Date', new Date().toISOString().split('T')[0]));

    isNotNullOrBlank(values.loanAmount) && application.appendChild(createElement(doc, 'Amount', values.loanAmount));
    isNotNullOrBlank(values.loanReason) && application.appendChild(createElement(doc, 'Reason', MapLoanReasonsToLeadMarketLoanReason(values.loanReason)));
        
    return application;
}

const createPersonApplicant = (doc, values) => {
    const personApplicant = createElement(doc, 'Person_Applicant');

    isNotNullOrBlank(values.dateOfBirth) && personApplicant.appendChild(createElement(doc, 'Date_Of_Birth', createDate(values.dateOfBirth)));
    isNotNullOrBlank(values.lastName) && personApplicant.appendChild(createElement(doc, 'Last_Name', values.lastName));
    isNotNullOrBlank(values.firstName) && personApplicant.appendChild(createElement(doc, 'First_Name', values.firstName));

    personApplicant.appendChild(createContactMethods(doc, values));
    
    return personApplicant;
}

const createContactMethods = (doc, values) => {

    const contactMethods = createElement(doc, 'Contact_Methods');

    if(isNotNullOrBlank(values.mobilePhone)) {        
        const contactMethodMobile = createElement(doc, 'Contact_Method');
        const mobileContact = createElement(doc, 'Contact_Other');
        mobileContact.appendChild(createElement(doc, 'Contact_Type', 'MOB'));
        mobileContact.appendChild(createElement(doc, 'Contact_Value', values.mobilePhone));
        contactMethodMobile.appendChild(mobileContact);
        contactMethods.appendChild(contactMethodMobile);
    }
        
    if(isNotNullOrBlank(values.emailAddress)) {

        const contanctMethodEmail = createElement(doc, 'Contact_Method');
        const emailContact = createElement(doc, 'Contact_Other');
        emailContact.appendChild(createElement(doc, 'Contact_Type', 'EMAIL'));
        emailContact.appendChild(createElement(doc, 'Contact_Value', values.emailAddress));
        contanctMethodEmail.appendChild(emailContact);
        contactMethods.appendChild(contanctMethodEmail);
    }
    
    const contactMethodAddress = createElement(doc, 'Contact_Method');
    const address = createElement(doc, 'Address');
    address.appendChild(createElement(doc, 'Address_Line_1', createStreetAddress( values.unitNumber, values.streetNumber, values.street)));
    address.appendChild(createElement(doc, 'Suburb', values.suburb));
    address.appendChild(createElement(doc, 'State', values.state));
    address.appendChild(createElement(doc, 'Postcode', values.postCode));
    contactMethodAddress.appendChild(address);
    contactMethods.appendChild(contactMethodAddress);
            
    return contactMethods;
}

const createEmploymentHistory = (doc, values) => {
    const employmentHistory = createElement(doc, 'Employment_History'); 
    const employment = createElement(doc, 'Employment');
    employment.appendChild(createElement(doc, 'Employment_Type', MapEmploymentTypeToLeadMarketLoanReason(values.employmentBasis ?? "")));
    employmentHistory.appendChild(employment);
    
    return employmentHistory;
};

const createApplicant = (doc, values) => {
    const applicant = createElement(doc, 'Applicant');
    
    applicant.appendChild(createPersonApplicant(doc, values));
    applicant.appendChild(createEmploymentHistory(doc, values));
    
    return applicant;
}

const createElement = (doc, tagName, value = '') => {
    const element = doc.createElement(tagName);
    if (value) element.textContent = value;
    return element;
};

const createDate = (dateOfBirth) => {    
    const {day, month, year} = dateOfBirth;

    const monthStr = month.toString().padStart(2, '0');    
    const dayStr = day.toString().padStart(2, '0');
    const dateStr = `${year}-${monthStr}-${dayStr}`;    
                
    return new Date(dateStr).toISOString().split('T')[0];
}   

const createStreetAddress = ( unitNumber, streetNumber, streetName ) => {

    if(unitNumber) {
        return unitNumber + "/" + streetNumber + "" + streetName;
    }

    return streetNumber + " " + streetName;
}


const xmlToString = (xmlDoc) => new XMLSerializer().serializeToString(xmlDoc);

const isNotNullOrBlank = (value) => value !== null && value !== undefined && value !== '';

const MapLoanReasonsToLeadMarketLoanReason = (loanReason) => convertAppFormLoanReasonToLeadMarketLoanReason(loanReason);

const MapEmploymentTypeToLeadMarketLoanReason = (employmentBasis) => convertAppIncomeSourceToLeadMarketIncomeSource(employmentBasis);
